export default {
  methods: {
    criteria(obj) {
      var conditions = [];

      var orderStatus = obj.orderStatus = obj.orderStatus ? obj.orderStatus : [];
      var statusIn = orderStatus.filter(e => "ticket-status-is-null" != e);
      var statusIsNull = orderStatus.filter(e => "ticket-status-is-null" == e).length;

      // console.log('#10 obj.orderStatus=', obj.orderStatus, 'statusIn=', statusIn, 'statusIsNull=', statusIsNull);

      if( statusIn.length > 0 && statusIsNull ) { // 状态为空或为指定值
        conditions.push({
          "$or" : [
            {
              "$is_null" : "orderStatus"
            }, {
              "$in" : {
                "orderStatus" : statusIn
              }
            }
          ]
        });
      } else if( statusIn.length > 0 ) { // 状态为指定值
        conditions.push({
          "$in" : {
            "orderStatus" : statusIn
          }
        });
      } else if( statusIsNull ) { // 状态为空
        conditions.push({
          "$is_null" : "orderStatus"
        });
      }

      if( obj.ticketUpdateTimeBegin ) {
        conditions.push({
          "$ge" : {
            "updateTime" : obj.ticketUpdateTimeBegin + ' 00:00:00.000'
          }
        });
        conditions.push({
          "$le" : {
            "updateTime" : obj.ticketUpdateTimeEnd + ' 23:59:59.999'
          }
        });
      }

      if( obj.ticketCreateTimeBegin ) {
        conditions.push({
          "$ge" : {
            "createTime" : obj.ticketCreateTimeBegin + ' 00:00:00.000'
          }
        });
        conditions.push({
          "$le" : {
            "createTime" : obj.ticketCreateTimeEnd + ' 23:59:59.999'
          }
        });
      }

      if( obj.orderTitle ) {
        conditions.push({
          "$or" : [
            {
              "$like" : {
                "orderTitle" : "%" + obj.orderTitle + "%"
              }
            },
            {
              "$like" : {
                "orderContent" : "%" + obj.orderTitle + "%"
              }
            },
            {
              "$like" : {
                "orderId" : "%" + obj.orderTitle + "%"
              }
            }
          ]
        });
      }

      if( obj.creatorId ) {
        conditions.push({
          "$eq" : {
            "creatorId" : obj.creatorId
          }
        });
      }

      if( obj.tag ) {
        conditions.push({
          "$ticket_tag_like" : "%" + obj.tag + "%"
        });
      }

      if( obj.orderType ) {
        conditions.push({
          "$ticket_type_in" : obj.orderType
        });
      }

      if( obj.orderPriority ) {
        conditions.push({
          "$eq" : {
            "orderPriority" : obj.orderPriority
          }
        });
      }

      if( obj.dealUserId ) {
        conditions.push({
          "$eq" : {
            "dealUserId" : obj.dealUserId
          }
        });
      }

      // 最后解决人
      if( obj.solveUserId ) {
        conditions.push({
          "$final_solve_by" : obj.solveUserId
        });
      }

      if( obj.merchantId ) {
        conditions.push({
          "$eq" : {
            "merchantId" : obj.merchantId
          }
        });
      }

      if( obj.ticketCcId ) {
        conditions.push({
          "$ticket_cc_to" : obj.ticketCcId
        });
      }

      if( obj.projectIds ) {
        var inProjectIds = [];

        for ( var i = 0; i < obj.projectIds.length; i++ ) {
          inProjectIds.push({$in_project: obj.projectIds[i]});
        }

        if ( !!inProjectIds && inProjectIds.length > 0 ) {
          conditions.push({ "$or" : inProjectIds });
        }
      }

      // 没有有效的查询条件
      if ( conditions.length < 1 ) {
          return null;
      }

      return {
        "$and" : conditions
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/mixins/MixinCriteria.js